import { Injectable, OnDestroy, Provider } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Action } from './models';

export const /** @type {?} */ INIT = /** @type {?} */(( '@ngrx/store/init' as '@ngrx/store/init'));
export class ActionsSubject extends BehaviorSubject<Action>
  implements OnDestroy {
constructor() {
    super({ type: INIT });
  }
/**
 * @param {?} action
 * @return {?}
 */
next(action: Action): void {
    if (typeof action === 'undefined') {
      throw new TypeError(`Actions must be objects`);
    } else if (typeof action.type === 'undefined') {
      throw new TypeError(`Actions must have a type property`);
    }

    super.next(action);
  }
/**
 * @return {?}
 */
complete() {
    /* noop */
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    super.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ActionsSubject_tsickle_Closure_declarations() {
/** @type {?} */
ActionsSubject.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ActionsSubject.ctorParameters;
}


export const /** @type {?} */ ACTIONS_SUBJECT_PROVIDERS: Provider[] = [ActionsSubject];

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/store/src/actions_subject.ts